import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';

import { env } from '@amfam/environment';
import { FeatureFlagService } from '@amfam/shared/utility/feature-flag/data-access';
import { fromRouterActions } from '@amfam/shared/utility/navigation';

import { AuthService } from '../core';
import { ForgerockAuthService } from '../core/auth/forgerock-auth.service';

@Injectable()
/**
 *  This guard is used to redirect the partner users to the forgerock login page if they  are not logged in
 * if the user is logged in then we need dispatch to overview page
 */
export class LoginRedirectGuard {
  constructor(
    private forgerockAuthService: ForgerockAuthService,
    private featureFlagService: FeatureFlagService,
    private store: Store,
    private authService: AuthService
  ) {}
  async canActivate(route: ActivatedRouteSnapshot) {
    const forgerockEnabled = this.featureFlagService.isEnabled('forgerock');

    let loggedIn = forgerockEnabled
      ? this.forgerockAuthService.isLoggedIn()
      : this.authService.isLoggedIn();

    if (!loggedIn) {
      try {
        loggedIn = await firstValueFrom(
          forgerockEnabled ? this.forgerockAuthService.refresh() : this.authService.refresh()
        );
      } catch (err) {
        loggedIn = false;
      }
    }

    if (loggedIn) {
      this.store.dispatch(
        fromRouterActions.Go({
          path: ['/overview']
        })
      );
      return false;
    }
    if (!forgerockEnabled) {
      return true;
    } else {
      const expid = route.paramMap.get('expid');
      //partners
      if (expid) {
        localStorage.setItem('expid', expid);

        this.forgerockAuthService.getTokens(env.forgerock.login, false);
        return false;
      }

      return true;
    }
  }
}
